const PHONE_REGEX_FORMAT = /\d{2}[ ]\d{1}[ ]\d{4}[.]\d{4}/g;

export default function phoneValidation(phone: string) {
  if (PHONE_REGEX_FORMAT.test(phone)) return true;

  return false;
}
